import React, { useEffect, useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const TikTokThumbnail = ({ url, onThumbnailReady }) => {
  const [thumbnail, setThumbnail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!url) return;

    const fetchThumbnail = async () => {
      setLoading(true);
      setError("");
      try {
        const res = await axios.get(`${API_URL}/api/videos/tiktokthumbnail`,{ params: { url } });
        setThumbnail(res.data.thumbnail);

        // Appelle le callback pour mettre à jour le state parent
        if (onThumbnailReady) onThumbnailReady(res.data.thumbnail);
      } catch (err) {
        console.error("Erreur récupération thumbnail TikTok:", err);
        setError("Impossible de récupérer le thumbnail");
      } finally {
        setLoading(false);
      }
    };

    fetchThumbnail();
  }, [url, onThumbnailReady]);

  if (loading) return <p>Chargement du thumbnail…</p>;
  if (error) return <p>{error}</p>;
  if (!thumbnail) return null;

  return (
    <a href={url} target="_blank" rel="noopener noreferrer">
      <img
        src={thumbnail}
        alt="TikTok video"
        style={{ maxWidth: "100%", borderRadius: "8px" }}
      />
    </a>
  );
};

export default TikTokThumbnail;
